import * as React from 'react';

import { ISliderContextProps, ISwiper } from '../types';

export const SliderContext = React.createContext<ISliderContextProps>({
  setSlider: () => null,
  setActiveSlide: () => null,
  resetSlider: () => null,
  activeSlide: 0,
  swiper: null,
});

export function SliderProvider({ children }: { children: React.ReactNode }) {
  const [slider, setSlider] = React.useState<ISwiper | null>();
  const [activeSlide, setActiveSlide] = React.useState(0);
  const setSliderHandler = React.useCallback(
    (value: ISwiper) => setSlider(value),
    [],
  );
  const setActiveSlideHandler = React.useCallback(
    (value: number) => setActiveSlide(value),
    [],
  );
  const resetSlider = React.useCallback(() => {
    slider?.swiper.destroy();
    setSlider(null);
    setActiveSlide(0);
  }, []);

  const context = React.useMemo(
    () => ({
      swiper: slider,
      activeSlide,
      setSlider: setSliderHandler,
      setActiveSlide: setActiveSlideHandler,
      resetSlider,
    }),
    [setSliderHandler, slider, activeSlide, resetSlider, setActiveSlideHandler],
  );

  return (
    <SliderContext.Provider value={context}>{children}</SliderContext.Provider>
  );
}
